module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center5"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("One thousand people are very few. In a world in which millions are dying, the statistically minded might say that it’s hardly worthwhile to save a mere 1,000 lives. What is one or what is 100 amongst a million?")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("But what is one is not a statistical question if that one happens to be you. The whole fate of mankind is encompassed in a single person, and in a single person is the whole fate of mankind")]), _vm._v(".")]), _c('a', {
    attrs: {
      "id": "isup1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Notes#sup1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("—Dorothy Thompson, introducing the radio program “Christmas in Freedom,” featuring the refugees of the Fort Ontario Emergency Shelter, December 1944")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46603da6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preface1.vue
// module id = 72
// module chunks = 0